import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ActionDto } from '@shared/src/dtos/maintenance/action/actionDto';
import { ActionsStripDto } from '@shared/src/dtos/maintenance/action/ActionsStripDto';
import { ShipmentDeliveryLineBatchInfoDetailDto, ShipmentDeliveryLineBatchInfoDto } from '@shared/src/dtos/shipment/delivery/ShipmentDeliveryLineBatchInfoDto';

/***
 * Taula de lots de fabricació d'una línia d'albarà (núm. lot, dates de
 * fabricació i caducitat, caixes, unitats, pes brut i pes net), amb alta i
 * baixa de lots i el resum del peu.
 *
 * No desa res: només edita l'objecte que rep i avisa amb (valueChanged);
 * qui el conté (l'editor de línies) decideix quan es persisteix.
 */
@Component({
    selector: 'shared-delivery-line-batchinfo',
    templateUrl: './shared.delivery.line.batchinfo.component.html',
    styleUrls: ['./shared.delivery.line.batchinfo.component.scss']
})
export class SharedDeliveryLineBatchInfoComponent {

    @Input() public readonly: boolean = false;

    /*** Nombre de caixes esperat a la línia, per contrastar-lo amb la suma dels lots */
    @Input() public expectedBoxQuantity: number = null;

    @Input() public batchInfo: ShipmentDeliveryLineBatchInfoDto;

    @Output() public valueChanged: EventEmitter<ShipmentDeliveryLineBatchInfoDto> = new EventEmitter();
    @Output() public addBatch: EventEmitter<void> = new EventEmitter();
    @Output() public deleteBatch: EventEmitter<ShipmentDeliveryLineBatchInfoDetailDto> = new EventEmitter();

    public static readonly ACTIONADD: string = "DELIVERYLINE.BATCHINFO.ADD";

    /*** "Afegir lot" va per l'strip d'actions, no com a botó solt */
    public batchActions: ActionsStripDto = new ActionsStripDto();

    constructor() {
        let actions = new ActionsStripDto();
        actions.add(ActionDto.build(SharedDeliveryLineBatchInfoComponent.ACTIONADD,
            'DELIVERYLINE.BATCHINFO.ADD.BUTTON', 'DELIVERYLINE.BATCHINFO.ADD.BUTTON', 'fa-plus', 10, 0, 1, '').setAdd());
        this.batchActions = actions;
    }

    public onBatchAction(action: ActionDto) {
        if (action == null || this.readonly)
            return;
        if (action.actionId === SharedDeliveryLineBatchInfoComponent.ACTIONADD)
            this.onAddBatch();
    }

    public get details(): ShipmentDeliveryLineBatchInfoDetailDto[] {
        return ShipmentDeliveryLineBatchInfoDto.getDetails(this.batchInfo);
    }

    public onAddBatch() {
        if (this.readonly)
            return;
        this.addBatch.next();
    }

    public onDeleteBatch(detail: ShipmentDeliveryLineBatchInfoDetailDto) {
        if (this.readonly)
            return;
        this.deleteBatch.next(detail);
    }

    public onValueChanged() {
        if (this.readonly)
            return;
        this.valueChanged.next(this.batchInfo);
    }

    public get batchCount(): number {
        return ShipmentDeliveryLineBatchInfoDto.countBatches(this.batchInfo);
    }

    public get totalBoxQuantity(): number {
        return ShipmentDeliveryLineBatchInfoDto.totalBoxQuantity(this.batchInfo);
    }

    public get totalNetWeightInKg(): number {
        return ShipmentDeliveryLineBatchInfoDto.totalNetWeightInKg(this.batchInfo);
    }

    /*** true si la suma de caixes dels lots no quadra amb la de la línia */
    public get boxQuantityMismatch(): boolean {
        if (this.expectedBoxQuantity == null || this.batchCount === 0)
            return false;
        return +this.expectedBoxQuantity !== this.totalBoxQuantity;
    }
}
